import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import { IsSmallScreen } from "../../commonFunctions/CommonFunctions";
import WSBottomNav from "../AppBar/WSAppBar";
import { Home, ContactPhone, Leaderboard } from "@mui/icons-material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import WarningModal from "../../FrontEnd/Common/WarninModal";
import { useAuth } from "../../StateManagement/authContext";
import Footer from "./Footer";

const DashboardLayout: React.FC = () => {
  // Define color variables
  const primaryColor = "";
  const secondaryColor = "";
  const hoverColor = "linear-gradient( #4DD26B 0%, #08B1B6 100%)";
  const iconColor = "#666666";
  const textColor = "#666666";
  const hoverTextColor = "#fff";
  const backgroundColor = "#fff";
  const selectedBackgroundColor =
    "linear-gradient(90deg, #4DD26B 0%, #08B1B6 100%)";
  const boxShadowColor = "rgba(209, 200, 200, 0.6)";

  const isMobile = IsSmallScreen();
  const { deactive } = useAuth();

  const [open, setOpen] = useState(true);
  const [collapse, setCollapse] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const myNavItems = [
    { path: "/home", icon: <Home />, label: "Home" },
    { path: "/leads/list", icon: <Leaderboard />, label: "Leads" },
    { path: "/contacts/list", icon: <ContactPhone />, label: "Contact" },
  ];

  const handleLoginAgain = () => {
    window.location.href = "/login";
  };

  const handleModalClose = () => {
    window.location.href = "/login";
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {!isMobile && (
        <Navbar
          anchorEl={anchorEl}
          collapse={collapse}
          backgroundColor={backgroundColor}
          handleCollapse={handleCollapse}
        />
      )}

      {!isMobile && <Sidebar
        collapse={collapse}
        handleCollapse={handleCollapse}
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        // bellow for color changes
        backgroundColor={backgroundColor}
        boxShadowColor={boxShadowColor}
        hoverColor={hoverColor}
        hoverTextColor={hoverTextColor}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        selectedBackgroundColor={selectedBackgroundColor}
        textColor={textColor}
        iconColor={iconColor}
      />}

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          marginTop: !isMobile ? "5.5rem" : "0.7rem", // Offset for AppBar height
          overflowY: "auto", // Enable scrolling for content only
          marginLeft: isMobile ? "0rem" : collapse ? "6rem" : "16rem",
        }}
      >
        <div style={{ padding: 10 }}>
          <Outlet />
        </div>
        <Footer />
      </Box>

      {isMobile && <WSBottomNav />}

      <WarningModal
        open={deactive}
        handleLoginAgain={handleLoginAgain}
        handleModalClose={handleModalClose}
      />
    </Box>
  );
};

export default DashboardLayout;